// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__gdC1l","upload":"Small_upload___n8vP","imageWrap":"Small_imageWrap__2mtBE","removeBtn":"Small_removeBtn__1ni08"};